import * as bootstrap from 'bootstrap';

export default class Modals {
  
  constructor() {
    const getStartedModals = document.querySelectorAll('.get-started');

    if (getStartedModals.length) {
      getStartedModals.forEach(getStartedModal => {
        this.getStartedModal = getStartedModal;
        this.initGetStartedModal();
      });
    }
  }
  
  initGetStartedModal() {
    const { title, sku } = this.getStartedModal.dataset;

    this.getStartedModal.addEventListener('click', function(e) {
      e.preventDefault();
      const modal = new bootstrap.Modal(document.getElementById('getStartedModal'), {
        animation: false
      });

      const modalTitle = document.querySelector('#getStartedModal .title');
      if (modalTitle) {
        modalTitle.textContent = 'Ready to get started with ' + title + '?';
      }
      if (sku) {
        const formSku = document.querySelector('#get-started-form #sku');
        if (formSku) {
          formSku.value = sku;
        }
      }

      modal.show();
    });
    
  }
}